import { Tooltip } from "antd";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import _ from "../../../i18n";
import { SettingsIcon } from "../../common/Icons";
import { RuleEditor } from "./RuleEditor";

const DraggableSettingDialog = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Tooltip placement="bottom" title={_("settings")}>
        <div
          role="button"
          onClick={() => setVisible(true)}
          style={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SettingsIcon fill="#29394d" />
        </div>
      </Tooltip>
      <Dialog
        header={_("suspectRules")}
        visible={visible}
        onHide={() => setVisible(false)}
        draggable
        resizable
        modal={false}
        dismissableMask={false}
        style={{ height: "80vh", width: "70%", position: "realtive" }}
        className="financial-p-dialog"
      >
        <RuleEditor />
      </Dialog>
    </>
  );
};

export default DraggableSettingDialog;
